import moment from 'moment';
import {environment} from '../containers/environment';

export const util = {
  getTextNormalized,
  getTextNormalizedCity,
  currencyMask,
  initUpperCase,
  getDiff,
  getDiffDayHigher,
  formatDateHoraToString,
  formatDateToString,
  formatDateToStringChat,
  convertMiliseconds,
  formatMiliseconds,
  getDropZoneInfoHere,
  getReadableFileSizeString,
  sortList,
  getDeviceType,
  wifiON,
  wifiSlow
};

function getTextNormalized(text){
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
}

function getTextNormalizedCity(text){
  return getTextNormalized(text).replace("`", "");
}

function currencyMask(value){
  let lng = localStorage.getItem(environment.LANGUAGE);
  let option = 'br';
  if(lng !== null && lng !== undefined){
    option = lng;
  }
  if(option === 'br'){
    return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
  }
  return value.toLocaleString('en-us',{style: 'currency', currency: 'USD'});
}

function initUpperCase(value){
    return value.substr(0,1).toUpperCase() + value.substr(1,value.length);
}

function getDiff(createdAt){
  let time = '';
  let diff = Math.abs(new Date() - new Date(createdAt));
  let seconds = Math.floor(diff/1000);
  let minutes = Math.floor(seconds/60);
  seconds = Math.floor(seconds%60);
  let hours = Math.floor(minutes/60);
  minutes = Math.floor(minutes%60);
  let days = Math.floor(hours/24);
  hours = Math.floor(hours%24);
  let months = Math.floor(days/30);
  days = Math.floor(days%30);
  let years = Math.floor(months/12);
  months = Math.floor(months%12);

  let lng = localStorage.getItem(environment.LANGUAGE);
  let option = 'br';
  if(lng !== null && lng !== undefined){
    option = lng;
  }
  if(option === 'br'){
    if(years > 0){
      time = (years > 1 ? "Há " + years + " anos" : "Há " + years + " ano"); 
    } else if(months > 0){
      time = (months > 1 ? "Há " + months + " meses" : "Há " + months + " mês"); 
    } else if(days > 0){
      time = (days > 1 ? "Há " + days + " dias" : "Há " + days + " dia"); 
    } else if(hours > 0){
      time = (hours > 1 ? "Há " + hours + " horas" : "Há " + hours + " hora"); 
    } else if(minutes > 0){
      time = (minutes > 1 ? "Há " + minutes + " minutos" : "Há " + minutes + " minuto"); 
    } else if(seconds > 0){
      time = (seconds > 1 ? "Há " + seconds + " segudos" : "Há " + seconds + " segundo"); 
    }
    time = time + " atrás";
  }else{
    if(years > 0){
      time = (years > 1 ? years + " years" : years + " year"); 
    } else if(months > 0){
      time = (months > 1 ? months + " months" : months + " month"); 
    } else if(days > 0){
      time = (days > 1 ? days + " days" : days + " day"); 
    } else if(hours > 0){
      time = (hours > 1 ? hours + " hours" : hours + " hour"); 
    } else if(minutes > 0){
      time = (minutes > 1 ? minutes + " minutes" : minutes + " minute"); 
    } else if(seconds > 0){
      time = (seconds > 1 ? seconds + " seconds" : seconds + " second"); 
    }
    time = time + " ago";
  }
  
  return time;
}

function getDiffDayHigher(start, end, daysLimit){
  let diff = Math.abs(end - start);
  let seconds = Math.floor(diff/1000);
  let minutes = Math.floor(seconds/60);
  let hours = Math.floor(minutes/60);
  let days = Math.floor(hours/24);

  if(days > daysLimit){
    return true;
  } 
  return false;
}

function formatDateHoraToString(date, defaultReturn) {
  if(date !== null && date !== undefined && date !== "" ){
    let lng = localStorage.getItem(environment.LANGUAGE);
    let option = 'br';
    if(lng !== null && lng !== undefined){
      option = lng;
    }
    moment.locale(option);
    if(option === 'br'){
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
    return moment(date).format('YYYY/MM/DD hh:mm A');
  }
  return defaultReturn;
}

function formatDateToString(date, defaultReturn) {
  if(date !== null && date !== undefined && date !== "" ){
    let lng = localStorage.getItem(environment.LANGUAGE);
    let option = 'br';
    if(lng !== null && lng !== undefined){
      option = lng;
    }
    moment.locale(option);
    if(option === 'br'){
      return moment(date).format('DD/MM/YYYY');
    }
    return moment(date).format('YYYY/MM/DD');
  }
  return defaultReturn;
}

function compareDates(date) {
  let dateChat = new Date(date);
  let currentDate = new Date();
  let diffTime = currentDate - dateChat;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

function formatDateToStringChat(date, defaultReturn) {
  if(date !== null && date !== undefined && date !== "" ){
    let lng = localStorage.getItem(environment.LANGUAGE);
    let option = 'br';
    if(lng !== null && lng !== undefined){
      option = lng;
    }
    moment.locale(option);

    let dateText = moment(date).format('LT');
    let diffTime = compareDates(date);
    if(diffTime > 1){
      if(option === 'br'){
        dateText = moment(date).format('DD/MM/YYYY');
      }else{
        dateText = moment(date).format('YYYY/MM/DD');
      }
      return dateText;
    }
  }
  return defaultReturn;
}

function convertMiliseconds(miliseconds, format) {
  var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;
  
  total_seconds = parseInt(Math.floor(miliseconds / 1000));
  total_minutes = parseInt(Math.floor(total_seconds / 60));
  total_hours = parseInt(Math.floor(total_minutes / 60));
  days = parseInt(Math.floor(total_hours / 24));

  seconds = parseInt(total_seconds % 60);
  minutes = parseInt(total_minutes % 60);
  hours = parseInt(total_hours % 24);
  
  switch(format) {
	case 's':
		return total_seconds;
	case 'm':
		return total_minutes;
	case 'h':
		return total_hours;
	case 'd':
		return days;
	default:
		return { d: days, h: hours, m: minutes, s: seconds };
  };
}

function formatMiliseconds(miliseconds) {
  let obj = convertMiliseconds(miliseconds, '') ;
  let time = "";

  let day = " day";
  let hour = " hour";
  let minute = " minute";
  let second = " second";
  let e = " and ";

  let lng = localStorage.getItem(environment.LANGUAGE);
  let option = 'br';
  if(lng !== null && lng !== undefined){
    option = lng;
  }
  if(option === 'br'){
    day = " dia";
    hour = " hora";
    minute = " minuto";
    second = " segundo";
    e = " e ";
  }

  if(obj.d > 0){
    time = obj.d + (obj.d > 1 ? day+"s" : day); 
    if(obj.h > 0){
      time = time + e + obj.h + (obj.h === 1 ?  hour : hour+"s");
    }
  }else{
    if(obj.h > 0){
      time = obj.h + (obj.h === 1 ?  hour : hour+"s");
      if(obj.m > 0){
        time = time + e + obj.m + (obj.m === 1 ? minute : minute+"s"); 
      }
    }else{
      if(obj.m > 0){
        time = obj.m + (obj.m === 1 ? minute : minute+"s"); 
        if(obj.s > 0){
          time = time + e + obj.s + (obj.s === 1 ? second : second+"s"); 
        }
      }else{
        if(obj.s > 0){
          time = obj.s + (obj.s === 1 ? second : second+"s"); 
        }
      }
    }
  }
  return time;
}

function getDropZoneInfoHere(){
  let lng = localStorage.getItem(environment.LANGUAGE);
  let option = 'br';
  if(lng !== null && lng !== undefined){
    option = lng;
  }
  let txts = {};
  if(option === 'br'){
    txts = {
      infohere: "Solte os arquivos aqui",
      remove: "Remover"
    };
  }else{
    txts = {
      infohere: "Drop file here",
      remove: "Remove"
    };
  }
  return txts;
}

function getReadableFileSizeString(fileSizeInBytes) {
  var i = -1;
  var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
  do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
  } while (fileSizeInBytes > 1024);

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};

function sortList(subObj, list, field1, field2, field3, together, order = "asc"){
  if(order === "asc"){
    list = list.sort(function (a, b) {
      let list_a = [];
      let list_b = [];
      let txt = "";
      let num = "";
      let retorno = -1;
      let index = 0;
      let letter = '';
      let total = 0;
      let totalChar = 0;
      let field_a = "";
      let field_b = "";
  
      if(subObj == null){
        if(a[field1] == null && b[field1] == null && a[field2] == null && b[field2] == null){
          return 0;
        }else if(a[field1] == null && a[field2] == null){
          return -1;
        }else if(b[field1] == null && b[field2] == null){
          return 1;
        }
  
        if(!together){
          field_a = a[field1];
          if(field_a == null){
            field_a = "null" + a[field2];
          }
    
          field_b = b[field1];
          if(field_b == null){
            field_b = "null" + b[field2];
          }
        }else{
          field_a = a[field1];
          if(field_a == null){
            field_a = "null" + a[field2];
          }
          if(a[field3] != null){
            field_a = field_a + " " + a[field3];
          }
    
          field_b = b[field1];
          if(field_b == null){
            field_b = "null" + b[field2];
          }
          if(b[field3] != null){
            field_b = field_b + " " + b[field3];
          }
        }
      }else{
        if(a[subObj][field1] == null && b[subObj][field1] == null && a[subObj][field2] == null && b[subObj][field2] == null){
          return 0;
        }else if(a[subObj][field1] == null && a[subObj][field2] == null){
          return -1;
        }else if(b[subObj][field1] == null && b[subObj][field2] == null){
          return 1;
        }
  
        if(!together){
          field_a = a[subObj][field1];
          if(field_a == null){
            field_a = "null" + a[subObj][field2];
          }
    
          field_b = b[subObj][field1];
          if(field_b == null){
            field_b = "null" + b[subObj][field2];
          }
        }else{
          field_a = a[subObj][field1];
          if(field_a == null){
            field_a = "null" + a[subObj][field2];
          }
          if(a[subObj][field3] != null){
            field_a = field_a + " " + a[subObj][field3];
          }
    
          field_b = b[subObj][field1];
          if(field_b == null){
            field_b = "null" + b[subObj][field2];
          }
          if(b[subObj][field3] != null){
            field_b = field_b + " " + b[subObj][field3];
          }
        }
      }
  
      field_a = getTextNormalized(field_a.toLowerCase());
      field_b = getTextNormalized(field_b.toLowerCase());
  
      // console.log(field_a + " | " + field_b);
      // console.log(a);
      // console.log(b);
  
      total = field_a.length;
      while(index < total){
        letter = field_a[index];
        if(Number(letter) || letter == "0"){
          if(txt.length > 0){
            list_a.push(txt);
            txt = "";
          }
          num = num + letter;
        }else{
          if(num.length > 0){
            list_a.push(num);
            num = "";
          }
          if(letter == " " || letter == "_" || letter == "-"){
            if(txt.length > 0){
              list_a.push(txt);
              txt = "";
            }
          }else{
            txt = txt + letter;
          }
        }
        index++;
      }
      if(num.length > 0){
        list_a.push(num);
      }
      if(txt.length > 0){
        list_a.push(txt);
      }
  
      index = 0;
      txt = "";
      num = "";
      total = field_b.length;
      while(index < total){
        letter = field_b[index];
        if(Number(letter) || letter == "0"){
          if(txt.length > 0){
            list_b.push(txt);
            txt = "";
          }
          num = num + letter;
        }else{
          if(num.length > 0){
            list_b.push(num);
            num = "";
          }
          if(letter == " " || letter == "_" || letter == "-"){
            if(txt.length > 0){
              list_b.push(txt);
              txt = "";
            }
          }else{
            txt = txt + letter;
          }
        }
        index++;
      }
      if(num.length > 0){
        list_b.push(num);
      }
      if(txt.length > 0){
        list_b.push(txt);
      }
  
      // console.log("list_a");
      // console.log(list_a);
      // console.log(list_b);
  
      if(list_a.length > 0 && list_b.length > 0){
        total = list_a.length;
        if(total > list_b.length){
          total = list_b.length;
        }
  
        for(let i = 0; i < total; i++){
          //console.log(list_a[i] + " | " + list_b[i]);
          if(Number(list_a[i]) || list_a[i] == "0"){
            //console.log("a is num");
            if(Number(list_b[i]) || list_b[i] == "0"){
              //console.log("b is num");
              retorno = (parseInt(list_a[i]) > parseInt(list_b[i])) ? 1 : (parseInt(list_b[i]) > parseInt(list_a[i])) ? -1 : 0;  
            }else{
              retorno = 1;
            }
          }else{
            if(Number(list_b[i]) || list_b[i] == "0"){
              //console.log("b is num");
              retorno = -1;  
            }else{
              //console.log(list_a[i] + " | " + list_b[i]);
              totalChar = list_a[i].length;
              if(totalChar > list_b[i].length){
                totalChar = list_b[i].length;
              }
              for(let j = 0; j < totalChar; j++){
                //console.log(list_a[i][j] + " | " + list_b[i][j]);
                retorno = (list_a[i][j] > list_b[i][j]) ? 1 : (list_b[i][j] > list_a[i][j]) ? -1 : 0;
                if(retorno != 0){
                  break;
                }
              }
            }
          }
          //console.log("retorno = " + retorno);
          if(retorno != 0){
            return retorno;
          }
        }
  
        if(retorno == 0 && list_a.length > list_b.length){
          retorno = 1;
        }else if(retorno == 0 && list_a.length < list_b.length){
          retorno = -1;
        }
        
      }else{
        retorno = (field_a > field_b) ? 1 : -1;
      }
      
      return retorno;
    });
  }else{
    list = list.sort(function (a, b) {
      let list_a = [];
      let list_b = [];
      let txt = "";
      let num = "";
      let retorno = -1;
      let index = 0;
      let letter = '';
      let total = 0;
      let totalChar = 0;
      let field_a = "";
      let field_b = "";
  
      if(subObj == null){
        if(a[field1] == null && b[field1] == null && a[field2] == null && b[field2] == null){
          return 0;
        }else if(a[field1] == null && a[field2] == null){
          return 1;
        }else if(b[field1] == null && b[field2] == null){
          return -1;
        }
  
        if(!together){
          field_a = a[field1];
          if(field_a == null){
            field_a = "null" + a[field2];
          }
    
          field_b = b[field1];
          if(field_b == null){
            field_b = "null" + b[field2];
          }
        }else{
          field_a = a[field1];
          if(field_a == null){
            field_a = "null" + a[field2];
          }
          if(a[field3] != null){
            field_a = field_a + " " + a[field3];
          }
    
          field_b = b[field1];
          if(field_b == null){
            field_b = "null" + b[field2];
          }
          if(b[field3] != null){
            field_b = field_b + " " + b[field3];
          }
        }
      }else{
        if(a[subObj][field1] == null && b[subObj][field1] == null && a[subObj][field2] == null && b[subObj][field2] == null){
          return 0;
        }else if(a[subObj][field1] == null && a[subObj][field2] == null){
          return 1;
        }else if(b[subObj][field1] == null && b[subObj][field2] == null){
          return -1;
        }
  
        if(!together){
          field_a = a[subObj][field1];
          if(field_a == null){
            field_a = "null" + a[subObj][field2];
          }
    
          field_b = b[subObj][field1];
          if(field_b == null){
            field_b = "null" + b[subObj][field2];
          }
        }else{
          field_a = a[subObj][field1];
          if(field_a == null){
            field_a = "null" + a[subObj][field2];
          }
          if(a[subObj][field3] != null){
            field_a = field_a + " " + a[subObj][field3];
          }
    
          field_b = b[subObj][field1];
          if(field_b == null){
            field_b = "null" + b[subObj][field2];
          }
          if(b[subObj][field3] != null){
            field_b = field_b + " " + b[subObj][field3];
          }
        }
      }
  
      field_a = getTextNormalized(field_a.toString().toLowerCase());
      field_b = getTextNormalized(field_b.toString().toLowerCase());
  
      // console.log("list_a");
      // console.log(list_a);
      // console.log(list_b);
  
      total = field_a.length;
      while(index < total){
        letter = field_a[index];
        if(Number(letter) || letter == "0"){
          if(txt.length > 0){
            list_a.push(txt);
            txt = "";
          }
          num = num + letter;
        }else{
          if(num.length > 0){
            list_a.push(num);
            num = "";
          }
          if(letter == " " || letter == "_" || letter == "-"){
            if(txt.length > 0){
              list_a.push(txt);
              txt = "";
            }
          }else{
            txt = txt + letter;
          }
        }
        index++;
      }
      if(num.length > 0){
        list_a.push(num);
      }
      if(txt.length > 0){
        list_a.push(txt);
      }
  
      index = 0;
      txt = "";
      num = "";
      total = field_b.length;
      while(index < total){
        letter = field_b[index];
        if(Number(letter) || letter == "0"){
          if(txt.length > 0){
            list_b.push(txt);
            txt = "";
          }
          num = num + letter;
        }else{
          if(num.length > 0){
            list_b.push(num);
            num = "";
          }
          if(letter == " " || letter == "_" || letter == "-"){
            if(txt.length > 0){
              list_b.push(txt);
              txt = "";
            }
          }else{
            txt = txt + letter;
          }
        }
        index++;
      }
      if(num.length > 0){
        list_b.push(num);
      }
      if(txt.length > 0){
        list_b.push(txt);
      }
  
      //console.log(list_a);
      //console.log(list_b);
  
      if(list_a.length > 0 && list_b.length > 0){
        total = list_a.length;
        if(total > list_b.length){
          total = list_b.length;
        }
  
        for(let i = 0; i < total; i++){
          //console.log(list_a[i] + " | " + list_b[i]);
          if(Number(list_a[i]) || list_a[i] == "0"){
            //console.log("a is num");
            if(Number(list_b[i]) || list_b[i] == "0"){
              //console.log("b is num");
              retorno = (parseInt(list_a[i]) > parseInt(list_b[i])) ? -1 : (parseInt(list_b[i]) > parseInt(list_a[i])) ? 1 : 0;  
            }else{
              retorno = 1;
            }
          }else{
            if(Number(list_b[i]) || list_b[i] == "0"){
              //console.log("b is num");
              retorno = -1;  
            }else{
              //console.log(list_a[i] + " | " + list_b[i]);
              totalChar = list_a[i].length;
              if(totalChar > list_b[i].length){
                totalChar = list_b[i].length;
              }
              for(let j = 0; j < totalChar; j++){
                //console.log(list_a[i][j] + " | " + list_b[i][j]);
                retorno = (list_a[i][j] > list_b[i][j]) ? -1 : (list_b[i][j] > list_a[i][j]) ? 1 : 0;
                if(retorno != 0){
                  break;
                }
              }
            }
          }
          //console.log("retorno = " + retorno);
          if(retorno != 0){
            return retorno;
          }
        }
  
        if(retorno == 0 && list_a.length > list_b.length){
          retorno = -1;
        }else if(retorno == 0 && list_a.length < list_b.length){
          retorno = 1;
        }
        
      }else{
        retorno = (field_a > field_b) ? -1 : 1;
      }
      
      return retorno;
    });
  }

  //console.log(list);
  return list;
}

function getDeviceType(){
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|iPhone|Macintosh|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

function wifiON(){
  let isON = false;

  fetch('https://www.google.com/', {mode: 'no-cors',})
  .then(() => {
      //CONNECTED TO INTERNET
      isON = true;
  }).catch(() => {
    //INTERNET CONNECTIVITY ISSUE
  });
  return isON;
}

function wifiSlow(){
  let isSlow = false;

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection) {
    if (connection.effectiveType === 'slow-2g'){// 'slow-2g', '2g', '3g', or '4g'
      //INTERNET CONNECTIVITY SLOW
      isSlow = true;
    }
  }

  return isSlow;
}